import { PropTypes } from "@material-ui/core";
import * as React from "react";

import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Text,
    useNotifications,
} from "../";
import { RelodeApiError } from "../../modules";

interface ConfirmationDialogProps {
    cancelLabel?: string;
    confirmLabel?: string;
    message: string;
    onClose: () => void;
    onConfirm: () => void;
    open: boolean;
    title: string;
}

export const ConfirmationDialog = React.memo(
    (props: ConfirmationDialogProps) => {
        const { actions: notifications } = useNotifications();
        const [buttonsEnabled, setButtonsEnabled] = React.useState(true);

        const {
            cancelLabel,
            confirmLabel,
            message,
            onClose,
            onConfirm,
            open,
            title,
        } = props;

        const handleConfirm = async () => {
            setButtonsEnabled(false);
            await onConfirm();
            setButtonsEnabled(true);
            onClose();
        };

        const handleClose = () => {
            onClose();
            notifications.closeAreaNotification("dialogError");
        };

        return open ? (
            <Dialog data-cy="confirmation-dialog" open={open}>
                <DialogTitle title={title} onClose={handleClose} />
                <DialogContent notificationAreaName="dialogError">
                    <Text>{message}</Text>
                </DialogContent>
                <DialogActions>
                    <DialogActions.Button
                        label={confirmLabel ? confirmLabel : "Yes"}
                        onClick={handleConfirm}
                        disabled={!buttonsEnabled}
                        data-cy="confirm-yes"
                    />
                    <DialogActions.Button
                        label={cancelLabel ? cancelLabel : "No"}
                        onClick={handleClose}
                        disabled={!buttonsEnabled}
                        data-cy="confirm-no"
                        color="default"
                    />
                </DialogActions>
            </Dialog>
        ) : null;
    }
);
